export default __webpack_public_path__ + "static/media/top-background-chat.1f711d88.png";